/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscountDto
 */
export interface DiscountDto {
    /**
     * 
     * @type {number}
     * @memberof DiscountDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof DiscountDto
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscountDto
     */
    isAllSectionsSelected: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscountDto
     */
    discountCodes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscountDto
     */
    sectionIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscountDto
     */
    productIds: Array<string>;
}

/**
 * Check if a given object implements the DiscountDto interface.
 */
export function instanceOfDiscountDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "isAllSectionsSelected" in value;
    isInstance = isInstance && "discountCodes" in value;
    isInstance = isInstance && "sectionIds" in value;
    isInstance = isInstance && "productIds" in value;

    return isInstance;
}

export function DiscountDtoFromJSON(json: any): DiscountDto {
    return DiscountDtoFromJSONTyped(json, false);
}

export function DiscountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'amount': json['amount'],
        'type': json['type'],
        'isAllSectionsSelected': json['isAllSectionsSelected'],
        'discountCodes': json['discountCodes'],
        'sectionIds': json['sectionIds'],
        'productIds': json['productIds'],
    };
}

export function DiscountDtoToJSON(value?: DiscountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'amount': value.amount,
        'type': value.type,
        'isAllSectionsSelected': value.isAllSectionsSelected,
        'discountCodes': value.discountCodes,
        'sectionIds': value.sectionIds,
        'productIds': value.productIds,
    };
}

